import React from 'react'
import Subject from './Subject'
import csm from '../assets/CSE401mid21.pdf'
import cse from '../assets/CSE401end21.pdf'
export default function Dm() {
  return (
    <div>
       <Subject title="Discrete Mathematics(CSE401)" sub="DM" syllabus="#" mid="Q. Paper"
    book1="Kenneth H. Rosen: Discrete Mathematics and its Applications, 7th Edition, McGraw Hill, 2011."
    book1Link="https://www.pdfdrive.com/download.pdf?id=86266202&h=a7d3a857b5d7b1868346f8fd7caccedd&u=cache&ext=pdf"
    book2="Deo N., “Graph Theory with Applications to Engineering and Computer Science”, PHI, 2004."
    book2Link="https://www.pdfdrive.com/download.pdf?id=196541416&h=98b61438ad661de58a7007900f77eb38&u=cache&ext=pdf"
     int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}
